// 신규 재무 요약 항목. 기본(en)을 다른 언어의 번역 누락 시에도 사용한다.
const en = {
  'LV{level} · 내 조직 통계': 'LV{level} · My organization analytics',
  '본인 포함 하위 관리자 {agents}명 / 소속 유저 {users}명 기준': 'Includes {agents} admins (self + descendants) and {users} linked players',
  '과거 시점의 조직별 보유 자산과 세션 평균은 원본 저장 방식상 제공되지 않습니다.': 'Historical organization balances and session averages are not available from the existing individual records.',
  '내 조직 게임 수수료': 'Game fees · my organization',
  '내 조직 유저 자산 보유량': 'Player assets · my organization',
  '내 조직 유저 라운지 포인트 보유량': 'Player lounge points · my organization',
  '내 조직 유저별 원장 및 접속 기록 기준으로 집계합니다.': 'Calculated from transactions and activity records belonging to my organization.',
  '게임서버 로컬 복구 파일 대기: VPS3 미기록 수수료가 있습니다.': 'Game-server local recovery pending: unreconciled fees exist on VPS3.',
  '게임서버 로컬 복구 상태가 없거나 오래되었습니다. VPS3 연결·복구 상태를 확인하세요.': 'Game-server local recovery status is missing or stale. Check VPS3 connectivity and recovery.',

  "동일 핸드 수수료 원장 중복이 확인되었습니다. 표시 합계는 최초 기록만 반영하며, 기존 중복 원장의 송금 상태는 별도 수동 확인이 필요합니다.": "Duplicate game-fee ledger entries found. Only the earliest entry counts; check sweep status of the duplicates manually.",
  "환전 확정 원장에서 유저를 확인할 수 없는 내역이 있습니다. 최종 값이 실제와 다를 수 있으므로 확인이 필요합니다.": "Some confirmed withdrawals could not be matched to users. Final value may be incomplete; please reconcile.",
  '최종 값': 'Final value',
  '별도 계산식 · 선택 기간 기준': 'Custom calculation · selected period',
  '(지정 유저 현상금 + LV1 게임 레이크백) − (지정 유저 제외 미션상금 + 유저 환전액)': '(Designated-user bounty + LV1 game rakeback) − (Regular-user mission prizes + all user withdrawals)',
  '게임 판 날짜 기준 · LV1 플레이어별 확정 분배 수수료 · 현상금 수수료 제외': 'Game-hand date basis · actual LV1 player-by-player settled allocations · bounty fees excluded',
  'LV1 동일 판·플레이어의 중복 지급 기록 또는 구형 합산 원장이 발견되었습니다. 표시 합계는 플레이어별 최초 기록만 반영하며 실제 잔액 중복 여부는 별도 확인이 필요합니다.': 'Duplicate LV1 credits for the same hand/player or legacy aggregated credits found. Only first credits per player are counted; check separately whether balances were credited twice.',
  '슈퍼어드민 수지 현황': 'Super Admin Financial Overview',
  '선택 기간 실제 원장 기준 · 지정 유저는 위 제외 유저 설정과 연동됩니다.': 'Based on settled records for the selected period. Designated users are managed through Excluded Users.',
  '지정 유저 관리': 'Manage designated users',
  '정산 데이터를 불러오는 중…': 'Loading settlement data…',
  '정산 데이터를 표시할 수 없습니다.': 'Financial data unavailable.',
  '플러스 · 수수료 / 잉여자금': 'INCOME · Fees / Event pool',
  '마이너스 · 실제 지급 / 환전': 'OUTFLOW · Paid rewards / Withdrawals',
  '슈퍼어드민 순수 게임 수수료': 'Super Admin Net Game Rakeback',
  'LV1 최상위 계정 실제 레이크백 지급분 · 현상금 수수료 제외': 'Rakeback actually credited to root LV1 (excluding bounty fee shares)',
  '잉여자금 · 매판 이벤트 수수료': 'Event Fund · Per-hand fees',
  '게임 정산 시 실제 차감된 이벤트 수수료 · USDT': 'Event fees actually withheld during game settlement · USDT',
  '유저 환전(출금) 금액': 'User Withdrawals',
  '성공 처리된 실제 환전 총액': 'Total successfully completed withdrawals',
  '일반 유저 미션 상금': 'Regular User Mission Rewards',
  '지정 유저 제외 · 데일리/테이블/레벨링/그룹 미션': 'Excludes designated users · daily/table/leveling/group missions',
  '지정 유저 미션 상금': 'Designated User Mission Rewards',
  '제외 유저 설정에서 지정한 유저에게 지급된 미션 상금': 'Mission prizes paid to users marked in Excluded Users',
  '지정 유저 현상금 획득': 'Designated User Bounty Payouts',
  '지정 유저의 현상금 실제 수령액 · 환불 제외': 'Actual bounty winnings received by designated users · no refunds',
  '수령자 미분류 과거 테이블 미션': 'Unattributed Legacy Table Missions',
  '과거 기록에 수상자 정보가 없어 일반/지정 유저로 임의 분배하지 않은 금액': 'Older prize records lack recipient details; they have not been allocated arbitrarily',
  '플러스 합계': 'Total income',
  '마이너스 합계': 'Total outflow',
  '단순 수지 차액 · 회계상 순이익 아님': 'Simple cash-flow-style difference · not accounting profit',
  '플러스 − 마이너스': 'Income − Outflow',
  '지정 유저 수': 'Designated users',
  '지정 유저 미션은 일반 유저 미션에서 중복 차감하지 않습니다. 환전액은 미션 등에서 발생한 금액이 다시 출금된 경우도 포함되므로 이 차액은 회계 손익이 아닙니다.': 'Designated mission rewards are excluded from regular mission rewards. Withdrawals can contain previously paid mission funds, so this difference is not accounting profit.',
  '과거 테이블 미션은 수령자별 내역이 없어 미분류로 표시됩니다.': 'Legacy table missions without recipient details appear as unattributed.',
  '에이전트 테이블 미션 상금': 'Agent Table Mission Rewards',
  '테이블 미션 플레이어 상금과 별도로 에이전트에게 실제 지급한 상금': 'Additional table mission rewards actually credited to agents, separate from player prizes',
  '이벤트 수수료 원장 재기록 대기 또는 확인 불가: 표시 금액은 확정 원장 기준이며 실제 차감액보다 작을 수 있습니다.': 'Event fee ledger is awaiting recovery or cannot be checked: confirmed amount shown may be less than fees withheld.',
  '체크한 유저는 전체 자산 집계에서 제외되며, 재무 대시보드의 일반/지정 유저 미션 상금 분류에도 적용됩니다. 라운지 포인트 통계에는 영향을 주지 않습니다.': 'Checked users are excluded from total asset holdings and classified separately in financial mission rewards. Lounge points are unaffected.',
  '변경 즉시 자산 집계 및 조회 기간의 일반/지정 유저 미션 분류가 다시 계산됩니다.': 'Changing a selection immediately updates assets and the regular/designated mission reward breakdown.',
  '건': ' items',
};
const ja = {
  '게임서버 로컬 복구 파일 대기: VPS3 미기록 수수료가 있습니다.': 'ゲームサーバーのローカル復旧待機: VPS3 に未記録の手数料があります。',
  '게임서버 로컬 복구 상태가 없거나 오래되었습니다. VPS3 연결·복구 상태를 확인하세요.': 'ゲームサーバーのローカル復旧状態が未報告または期限切れです。VPS3を確認してください。',

  "동일 핸드 수수료 원장 중복이 확인되었습니다. 표시 합계는 최초 기록만 반영하며, 기존 중복 원장의 송금 상태는 별도 수동 확인이 필요합니다.": "同じハンドの手数料台帳に重複があります。最初の記録のみを集計し、重複分の送金状態は手動確認が必要です。",
  "환전 확정 원장에서 유저를 확인할 수 없는 내역이 있습니다. 최종 값이 실제와 다를 수 있으므로 확인이 필요합니다.": "出金確定台帳の一部でユーザーを特定できません。最終値が不完全な可能性があるため確認してください。",
  '최종 값': '最終値',
  '별도 계산식 · 선택 기간 기준': '個別の計算式 · 選択期間',
  '(지정 유저 현상금 + LV1 게임 레이크백) − (지정 유저 제외 미션상금 + 유저 환전액)': '（指定ユーザーのバウンティ + LV1ゲームレーキバック）−（指定ユーザーを除くミッション報酬 + ユーザー出金額）',
  '에이전트 테이블 미션 상금': 'エージェントのテーブルミッション報酬',
  '이벤트 수수료 원장 재기록 대기 또는 확인 불가: 표시 금액은 확정 원장 기준이며 실제 차감액보다 작을 수 있습니다.': 'イベント手数料の台帳が復旧待ち、または確認できません。表示額は実際の徴収額より少ない場合があります。',
  '게임 판 날짜 기준 · LV1 플레이어별 확정 분배 수수료 · 현상금 수수료 제외': 'ゲームのハンド日付基準・LV1に分配されたプレイヤー別の確定手数料（バウンティ除外）',
  'LV1 동일 판·플레이어의 중복 지급 기록 또는 구형 합산 원장이 발견되었습니다. 표시 합계는 플레이어별 최초 기록만 반영하며 실제 잔액 중복 여부는 별도 확인이 필요합니다.': '同じハンド・プレイヤーへのLV1重複入金、または旧形式の合算記録を検出しました。プレイヤー別の初回記録だけ集計します。残高の二重入金は別途確認してください。',
  '슈퍼어드민 수지 현황': 'スーパー管理者の収支状況',
  '지정 유저 관리': '指定ユーザー管理',
  '플러스 · 수수료 / 잉여자금': 'プラス · 手数料 / イベント資金',
  '마이너스 · 실제 지급 / 환전': 'マイナス · 支払い / 出金',
  '슈퍼어드민 순수 게임 수수료': 'スーパー管理者の純ゲーム手数料',
  '잉여자금 · 매판 이벤트 수수료': '余剰資金 · 各ハンドのイベント手数料',
  '유저 환전(출금) 금액': 'ユーザー出金額',
  '일반 유저 미션 상금': '一般ユーザーのミッション報酬',
  '지정 유저 미션 상금': '指定ユーザーのミッション報酬',
  '지정 유저 현상금 획득': '指定ユーザーの賞金獲得',
  '수령자 미분류 과거 테이블 미션': '受取人不明の過去テーブルミッション',
  '플러스 합계': 'プラス合計',
  '마이너스 합계': 'マイナス合計',
  '플러스 − 마이너스': 'プラス − マイナス',
  '지정 유저 수': '指定ユーザー数',
};
const ru = {
  '게임서버 로컬 복구 파일 대기: VPS3 미기록 수수료가 있습니다.': 'Локальное восстановление на игровом сервере: на VPS3 есть неучтённые комиссии.',
  '게임서버 로컬 복구 상태가 없거나 오래되었습니다. VPS3 연결·복구 상태를 확인하세요.': 'Статус локального восстановления игрового сервера отсутствует или устарел. Проверьте VPS3.',

  "동일 핸드 수수료 원장 중복이 확인되었습니다. 표시 합계는 최초 기록만 반영하며, 기존 중복 원장의 송금 상태는 별도 수동 확인이 필요합니다.": "Найдены дубли комиссий по одной раздаче. Учтена только первая запись; проверьте статус переводов по дублям вручную.",
  "환전 확정 원장에서 유저를 확인할 수 없는 내역이 있습니다. 최종 값이 실제와 다를 수 있으므로 확인이 필요합니다.": "Некоторые подтверждённые выводы не удалось связать с пользователями. Итоговое значение может быть неполным.",
  '최종 값': 'Итоговое значение',
  '별도 계산식 · 선택 기간 기준': 'Отдельная формула · выбранный период',
  '(지정 유저 현상금 + LV1 게임 레이크백) − (지정 유저 제외 미션상금 + 유저 환전액)': '(Баунти выбранных пользователей + рейкбэк LV1) − (Награды за задания без выбранных пользователей + вывод средств)',
  '에이전트 테이블 미션 상금': 'Награды агентов за миссии стола',
  '이벤트 수수료 원장 재기록 대기 또는 확인 불가: 표시 금액은 확정 원장 기준이며 실제 차감액보다 작을 수 있습니다.': 'Учёт комиссий событий ожидает восстановления или недоступен; показанная сумма может быть меньше фактически удержанной.',
  '게임 판 날짜 기준 · LV1 플레이어별 확정 분배 수수료 · 현상금 수수료 제외': 'По дате раздачи · распределения LV1 по каждому игроку · без баунти',
  'LV1 동일 판·플레이어의 중복 지급 기록 또는 구형 합산 원장이 발견되었습니다. 표시 합계는 플레이어별 최초 기록만 반영하며 실제 잔액 중복 여부는 별도 확인이 필요합니다.': 'Найдены повторные начисления LV1 за одного игрока и раздачу или старые сводные записи. Учтено первое начисление на игрока; двойные зачисления на баланс проверяются отдельно.',
  '슈퍼어드민 수지 현황': 'Финансы суперадминистратора',
  '지정 유저 관리': 'Управление выбранными пользователями',
  '플러스 · 수수료 / 잉여자금': 'Доход · Комиссии / фонд событий',
  '마이너스 · 실제 지급 / 환전': 'Расход · Выплаты / вывод',
  '슈퍼어드민 순수 게임 수수료': 'Чистый рейкбэк суперадминистратора',
  '잉여자금 · 매판 이벤트 수수료': 'Фонд событий · сбор с каждой раздачи',
  '유저 환전(출금) 금액': 'Вывод средств пользователями',
  '일반 유저 미션 상금': 'Награды обычных пользователей',
  '지정 유저 미션 상금': 'Награды выбранных пользователей',
  '지정 유저 현상금 획득': 'Баунти выбранных пользователей',
  '수령자 미분류 과거 테이블 미션': 'Старые награды без данных о получателе',
  '플러스 합계': 'Итого доход',
  '마이너스 합계': 'Итого расход',
  '플러스 − 마이너스': 'Доход − расход',
  '지정 유저 수': 'Выбранных пользователей',
};
const zh = {
  '게임서버 로컬 복구 파일 대기: VPS3 미기록 수수료가 있습니다.': '游戏服务器本地恢复待处理：VPS3 上存在尚未入账的手续费。',
  '게임서버 로컬 복구 상태가 없거나 오래되었습니다. VPS3 연결·복구 상태를 확인하세요.': '游戏服务器本地恢复状态缺失或过期，请检查 VPS3。',

  "동일 핸드 수수료 원장 중복이 확인되었습니다. 표시 합계는 최초 기록만 반영하며, 기존 중복 원장의 송금 상태는 별도 수동 확인이 필요합니다.": "发现同一牌局的手续费账本重复记录。仅统计最早记录，请手动检查重复记录的转账状态。",
  "환전 확정 원장에서 유저를 확인할 수 없는 내역이 있습니다. 최종 값이 실제와 다를 수 있으므로 확인이 필요합니다.": "部分已确认提现无法关联用户，最终值可能不完整，请核查。",
  '최종 값': '最终值',
  '별도 계산식 · 선택 기간 기준': '独立计算公式 · 所选期间',
  '(지정 유저 현상금 + LV1 게임 레이크백) − (지정 유저 제외 미션상금 + 유저 환전액)': '（指定用户悬赏金 + LV1游戏返佣）−（不含指定用户的任务奖金 + 用户提现金额）',
  '에이전트 테이블 미션 상금': '代理桌面任务奖励',
  '이벤트 수수료 원장 재기록 대기 또는 확인 불가: 표시 금액은 확정 원장 기준이며 실제 차감액보다 작을 수 있습니다.': '活动手续费账本待恢复或无法核实，显示金额可能低于实际扣除额。',
  '게임 판 날짜 기준 · LV1 플레이어별 확정 분배 수수료 · 현상금 수수료 제외': '按牌局日期统计·LV1按玩家分配的已结算手续费·不含悬赏手续费',
  'LV1 동일 판·플레이어의 중복 지급 기록 또는 구형 합산 원장이 발견되었습니다. 표시 합계는 플레이어별 최초 기록만 반영하며 실제 잔액 중복 여부는 별도 확인이 필요합니다.': '发现同一牌局与玩家的LV1重复入账或旧版汇总记录。仅计入每位玩家的首条记录；余额是否重复入账须另行核查。',
  '슈퍼어드민 수지 현황': '超级管理员收支概览',
  '지정 유저 관리': '管理指定用户',
  '플러스 · 수수료 / 잉여자금': '收入 · 手续费 / 活动资金',
  '마이너스 · 실제 지급 / 환전': '支出 · 奖励 / 提现',
  '슈퍼어드민 순수 게임 수수료': '超级管理员净游戏佣金',
  '잉여자금 · 매판 이벤트 수수료': '活动资金 · 每手活动手续费',
  '유저 환전(출금) 금액': '用户提现金额',
  '일반 유저 미션 상금': '普通用户任务奖励',
  '지정 유저 미션 상금': '指定用户任务奖励',
  '지정 유저 현상금 획득': '指定用户悬赏奖励',
  '수령자 미분류 과거 테이블 미션': '收款人不明的历史牌桌任务',
  '플러스 합계': '收入合计',
  '마이너스 합계': '支出合计',
  '플러스 − 마이너스': '收入 − 支出',
  '지정 유저 수': '指定用户数',
};
export default { en, ja, ru, zh };
